import { render, staticRenderFns } from "./StudyManagement.vue?vue&type=template&id=077ec415&scoped=true&"
import script from "./StudyManagement.vue?vue&type=script&lang=js&"
export * from "./StudyManagement.vue?vue&type=script&lang=js&"
import style0 from "./StudyManagement.vue?vue&type=style&index=0&id=077ec415&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077ec415",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VChip,VListItem,VListItemAvatar,VListItemContent})
